import { render, staticRenderFns } from "./ActiveInstalls.vue?vue&type=template&id=3dcd484a"
import script from "./ActiveInstalls.vue?vue&type=script&lang=js"
export * from "./ActiveInstalls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports